﻿<script>
    import { onMount } from 'svelte';

    import lookups from '../stores/lookupStore';
    import Person from '../models/Person';

    import TextInput from './TextInput.svelte';
    import Checkbox from './Checkbox.svelte';
    import Select from './Select.svelte';
    import FormRow from './FormRow.svelte';
    import FormColumn from './FormColumn.svelte';
    import AddButton from './buttons/AddButton.svelte';

    export let trustName;
    export let trustees;
    export let contactIsTrustee;
    export let contactFirstName = null;
    export let contactSurname = null;
    export let authorisedToAct = null;
    export let disabled = null;
    
    const addTrustee = () => {
        trustees = [ ...trustees, new Person()];
    }

    const deleteTrustee = (index) => {
        if (trustees.length <= 1) return;

        if (trustees[index].isContact) {
            contactIsTrustee = false;
        }

        trustees.splice(index, 1);
        trustees = [ ...trustees];
    }

    const handleContactIsTrusteeChange = (e) => {
        if (e.target.checked) {
            let contact = new Person();
            contact.firstName = contactFirstName;
            contact.surname = contactSurname;
            contact.isContact = true;

            trustees.unshift(contact);

            let indexEmptyContact = trustees.findIndex(e => !e.firstName && !e.surname);
            if (indexEmptyContact >= 0) {
                deleteTrustee(indexEmptyContact);
            }
        } else {
            let indexContact = trustees.findIndex(e => e.isContact);
            if (indexContact >= 0) {
                if (trustees[indexContact].isContact && trustees .length === 1) {
                    trustees[indexContact].isContact = false;
                    trustees[indexContact].firstName = null;
                    trustees[indexContact].surname = null;
                } else {
                    trustees.splice(indexContact, 1);
                }
            }
        }

        trustees = [...trustees];
    }

    const handleContactNameChange = (contactFirstName, contactSurname) => {
        if (contactIsTrustee) {
            var indexContact = trustees.findIndex(e => e.isContact);
            if (indexContact >= 0) {
                trustees[indexContact].firstName = contactFirstName;
                trustees[indexContact].surname = contactSurname;
            }
        }

        trustees = [...trustees];
    }

    $: {
        handleContactNameChange(contactFirstName, contactSurname);
    }

    onMount(() => {
        if (!trustees.length) {
            addTrustee();
        }
    })

</script> 

<FormRow>
    <FormColumn cols="12">
        <h3>Trust Details</h3>
    </FormColumn>
</FormRow>

<FormRow>
    <FormColumn cols="12">
        <TextInput
            required
            {disabled}
            label="Trust name"
            bind:value="{trustName}"
            id="claimantSurname"
            maxlength="50" />
    </FormColumn>
</FormRow>

<FormRow>
    <FormColumn>
        <Checkbox {disabled}
            on:change={handleContactIsTrusteeChange}
            bind:checked="{contactIsTrustee}"
            label="I am a trustee"
            id="contactIsTrustee"></Checkbox>
    </FormColumn>
</FormRow>

<FormRow class="mt-0">
    <FormColumn cols="11">
        <FormRow>
            <FormColumn cols="6" class="d-none d-md-block">
                <!-- svelte-ignore a11y-label-has-associated-control -->
                <label>
                    Trustee first name
            		<span class="required">*</span>
                </label>
            </FormColumn>
            <FormColumn cols="6" class="d-none d-md-block">
                <!-- svelte-ignore a11y-label-has-associated-control -->
                <label>
                    Trustee last  name
            		<span class="required">*</span>
                </label>
            </FormColumn>
        </FormRow>
    </FormColumn>
</FormRow>

<div class="trustees">

    {#each trustees as trustee, i (trustee)}
 
        <div class="trustee">
            <FormRow class="mt-2">
                <FormColumn cols="11">
                    <FormRow class="mt-0">
                        <FormColumn cols="6">
                            <TextInput
                                required
                                disabled={disabled || trustee.isContact}
                                placeholder="Trustee first name"
                                bind:value="{trustee.firstName}"
                                id="firstName{i}"
                                maxlength="50" />
                        </FormColumn>
                        <FormColumn cols="6">
                            <TextInput
                                required
                                disabled={disabled || trustee.isContact}
                                placeholder="Trustee last  name"
                                bind:value="{trustee.surname}"
                                id="surname{i}"
                                maxlength="50" />
                        </FormColumn>
                    </FormRow>
                </FormColumn>
                <FormColumn cols="1" class="last mt-0">
                    {#if trustees.length > 1}
                        <div class="confirmation-hide">
                            <button on:click|preventDefault={() => deleteTrustee(i)} class="delete" title="Delete transaction" aria-label="Delete transaction">
                                 <i class="fas fa-trash"></i>
                            </button>
                        </div>
                    {/if}
                </FormColumn>
            </FormRow>
    
        </div>

    {/each}

    <div class="confirmation-hide" style="margin-top: 20px;">
        <AddButton on:add={addTrustee}>Add another trustee</AddButton>
    </div>
</div>

<FormRow>
    <FormColumn>
        <Checkbox {disabled}
            required
            bind:checked="{authorisedToAct}"
            label="I am authorised to act on behalf of the Trust"
            id="authorisedToAct"></Checkbox>
    </FormColumn>
</FormRow>

<style>

    .trustees {
        border-top: 1px solid var(--color-border);
    }

    .trustee {
        position: relative;
    }

    .delete {
        border: none;
        outline: none;
        background-color: transparent;
        font-size: 1.1rem;
        font-weight: 700;
        color: var(--color-primary);
        margin-top: 10px;
    }

</style>